import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChangePasswordSuccessComponent } from './components/change-password-success/change-password-success.component';
import { GeneratePasswordComponent } from './components/generate-password/generate-password.component';
import { SessionExpiredComponent } from './components/session-expired/session-expired.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { UserRegistrationResolver } from './resolvers/user-registration.resolver';


const routes: Routes = [
    {
      path: 'forgotpassverify/:forgotpass',
      component: GeneratePasswordComponent
    },
    {
      path: 'register/:guid',
      component: GeneratePasswordComponent,
      resolve: { userDetails: UserRegistrationResolver }
    },
    {
      path: 'pwd-success/:guid',
      component: ChangePasswordSuccessComponent
    },
    // {
    //   path: 'terms-and-conditions',
    //   component: TermsConditionsComponent,
    // },
    {
      path: 'session-expired',
      component: SessionExpiredComponent,
    },
    {
      path: 'set-pwd/:guid/:forgotpass',
      component: SetPasswordComponent,
    }
  ];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [UserRegistrationResolver]
  })
  export class UserRegistrationRoutingModule { }
